import { adminTemplateTableRow } from "./types";

export const adminTemplateMockData: adminTemplateTableRow[] = [
  {
    templateId: "DOC-PRD-01",
    templateName: "ADMIN_TEMPLATE.TEMPLATES.DOC_PRD_01.templateName",
    description: "ADMIN_TEMPLATE.TEMPLATES.DOC_PRD_01.description",
    format: "PDF",
    lastUpdate: "01/03/2026",
    version: 1.1
  },
  {
    templateId: "DOC-ENG-05",
    templateName: "ADMIN_TEMPLATE.TEMPLATES.DOC_ENG_05.templateName",
    description: "ADMIN_TEMPLATE.TEMPLATES.DOC_ENG_05.description",
    format: "DXF/PDF",
    lastUpdate: "01/03/2026",
    version: 2.0
  }
];